<template>
  <div class="form-group row">
    <div class="col-sm-2 text-sm-right">
      <label>Nome:</label>
    </div>
    <div class="col-md-4 col-sm-11 mb-3">
      <input type="text" class="form-control" v-model="filtro.nome">
    </div>

    <div class="col-sm-2 text-sm-right">
      <label>CPF:</label>
    </div>
    <div class="col-md-3 col-sm-11 mb-3">
      <the-mask :mask="['###.###.###-##']" type="text" class="form-control" v-model="filtro.cpf" />
    </div>

    <div class="col-12 row btnAcoes">
      <div class="col-1"></div>
      <button class="btn btn-outline-success" @click.prevent="consultar"> Pesquisar </button>
      <button class="btn btn-outline-danger" @click.prevent="limpar"> Limpar </button>
    </div>
  </div>
</template>

<script>
import InteressadoService from '@/services/InteressadoService'
import eventBus from '@/uteis/eventBus'

export default {
  props: {
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String }
  },

  data () {
    return {
      filtro: {
        tipoInteressado: 'PESSOAFISICA',
        cpf: '',
        nome: '',
        range: 5
      },
      columns: [
        [
          { key: 'nome', title: 'Nome' },
          { key: 'tipoContatoExterno', title: 'Tipo', converter: 'tipoContatoExterno' }
        ], [
          { key: 'identificador', title: 'Identificador' },
          { key: 'email', title: 'Email' }
        ]
      ]
    }
  },

  created () {
    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.consultar(numeroPagina)
    })

    this.service = new InteressadoService()
    this.consultar()
  },

  methods: {
    consultar (page = 1) {
      const dadosSessao = this.$store.getters.getDadosSessao
      this.filtro = {
        ...this.filtro,
        offset: page,
        idDepartamento: dadosSessao.sessao.idDepartamento
      }

      this.service.consultarInteressado(this.filtro).then(res => {
        eventBus.$emit(this.eventBusDataName, {
          ...res.data,
          id: 'id',
          columns: this.columns
        })
      }).catch(err => {
        console.log(err)
      })
    },

    limpar () {
      this.filtro = {
        ...this.filtro,
        cpf: '',
        nome: ''
      }
      this.consultar()
    }
  }
}
</script>
